import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import {
    selectUserActiveSubscriptions, selectUserOneShotOrders,
    selectUserOpenOrders,
} from '../../../../store/user/user.selectors';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import {AsyncPipe, CurrencyPipe, DatePipe, NgClass, NgIf} from '@angular/common';
import { NavigationService } from '../../../../services/navigation.service';
import {
    cancelOrder,
} from '../../../../store/create-order/create-order.actions';
import { APP_ROUTES } from '../../../../app.routes.definition';
import { cancelSubscription } from '../../../../store/cancel-subscription/cancel-subscription.actions';
import { ModalService } from '../../../../services/modal.service';
import {OrderItemProduct} from '../../../../models/order.models';
import {PromptModalComponent, PromptModalData} from "../../../../components/prompt-modal/prompt-modal.component";

@Component({
    selector: 'profile-page',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        TranslocoModule,
        RouterModule,
        NgxIntlTelInputModule,
        AsyncPipe,
        NgIf,
        NgClass,
        CurrencyPipe,
        DatePipe,
    ],
    templateUrl: './subscriptions-page.component.html',
})
export default class SubscriptionsPageComponent {
    #store = inject(Store);
    #navigationService = inject(NavigationService);
    #modalService = inject(ModalService);

    activeSubscription$ = this.#store.select(selectUserActiveSubscriptions);
    oneShotOrders$ = this.#store.select(selectUserOneShotOrders);
    pendingOrders$ = this.#store.select(selectUserOpenOrders);

    marketplacePath = APP_ROUTES.MARKETPLACE();
    productPath = APP_ROUTES.MARKETPLACE_PRODUCT;

    constructor() {
        this.#navigationService.saveCurrentRoute();
    }

    cancelSubscription(id: string, product: OrderItemProduct) {
        this.#modalService.open<PromptModalData, PromptModalComponent>(PromptModalComponent, {
            data: {
                title: `Sei sicuro di voler annullare l'abbonamento?`,
                message: `L'abbonamento "${product.name}" verrà annullato.`,
                onOkCallback: () => {
                    this.#store.dispatch(
                        cancelSubscription({
                            id: id,
                        })
                    );
                }
            },
        });
    }

    cancelOrder(id: string) {
        this.#store.dispatch(
            cancelOrder({
                id: id,
            })
        );
    }
}
